import hljs from "highlight.js/lib/core";

// register only what you need (add more as you like)
import sql from "highlight.js/lib/languages/sql";
import javascript from "highlight.js/lib/languages/javascript";
import json from "highlight.js/lib/languages/json";
import python from "highlight.js/lib/languages/python";
hljs.registerLanguage("sql", sql);
hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("js", javascript);
hljs.registerLanguage("json", json);
hljs.registerLanguage("python", python);

// token colors
import "highlight.js/styles/atom-one-dark.css";

export default function CodeWindow({
  code,
  lang = "text",
}: { code: string; lang?: string }) {
  const raw = (code ?? "").replace(/\n$/, "");
  const html =
    hljs.getLanguage(lang)
      ? hljs.highlight(raw, { language: lang }).value
      : hljs.highlightAuto(raw).value;

  const lines = html.split("\n");

  return (
    <div className="not-prose code-window rounded-xl overflow-hidden border border-white/10 bg-[#111827]">
      <div className="code-header flex items-center gap-2 px-3 py-2 bg-[#0B1220] border-b border-white/10">
        <span className="h-2.5 w-2.5 rounded-full bg-[#ff605c]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#ffbd44]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#00ca4e]" />
        <span className="ml-2 text-xs uppercase tracking-wide text-gray-300">
          {lang.toUpperCase()}
        </span>
      </div>

      <div className="code-body overflow-x-auto">
        <table className="code-table w-full border-collapse font-mono text-[0.95rem] leading-6">
          <tbody>
            {lines.map((l, i) => (
              <tr key={i}>
                <td className="code-gutter select-none whitespace-nowrap align-top text-right text-gray-400 bg-[#0F1629] border-r border-white/10 px-3 py-2 w-[3.25rem]">
                  {i + 1}
                </td>
                <td className="code-cell align-top px-3 py-2 !bg-transparent">
                  <code
                    className="hljs block !bg-transparent !p-0 !border-0 !shadow-none !rounded-none !text-gray-200"
                    dangerouslySetInnerHTML={{ __html: l || " " }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}